// extracted by mini-css-extract-plugin
export default {"loader":"loading_loader__A8yIx","l3":"loading_l3__sBvfN"};